import { render, staticRenderFns } from "./TripList.vue?vue&type=template&id=48bcce94&scoped=true&"
import script from "./TripList.vue?vue&type=script&lang=js&"
export * from "./TripList.vue?vue&type=script&lang=js&"
import style0 from "./TripList.vue?vue&type=style&index=0&id=48bcce94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcce94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48bcce94')) {
      api.createRecord('48bcce94', component.options)
    } else {
      api.reload('48bcce94', component.options)
    }
    module.hot.accept("./TripList.vue?vue&type=template&id=48bcce94&scoped=true&", function () {
      api.rerender('48bcce94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trips/TripList.vue"
export default component.exports